<template>
  <LoadingSpinner v-if="loading" />
  <div
    v-else
    class="bg-white h-full w-full"
  >
    <GradientHeader
      :logo="logo"
      :colour="colours.primary"
      fullHeight
    >
      <OffsetColorBox
        :colour="colours.accentPrimary"
        :gray="colours.primaryIsWhite"
        class="w-160 max-w-full mx-auto px-4"
        smallHeading
        boxInnerClass="md:px-10"
      >
        <template slot="heading">
          {{ $t('otp.codeRequired') }}
        </template>

        <IconCircular
          slot="icon"
          class="bg-warn !w-10 !h-10 translate-y-1"
        >
          <LockIcon
            class="w-3/5 text-white"
          />
        </IconCircular>

        <OtpSendScreen
          v-if="!showEntry && !otpStatus.codeExpires"
          :mobileLastFour="otpStatus.mobileLastFour"
          :onSendCode="sendOtp"
          :error="otpStatus.requestError"
          :customisedBranding="branding && branding.customisedBranding"
          @showEntry="showEntry = true"
        />

        <OtpEntryScreen
          v-else
          :mobileLastFour="otpStatus.mobileLastFour"
          :expires="otpStatus.codeExpires"
          :verifyError="otpStatus.verifyError"
          :requestError="otpStatus.requestError"
          :codesSent="otpStatus.codesSent"
          :verifyOtp="handleVerifyOtp"
          :sendCode="sendOtp"
          :customisedBranding="branding && branding.customisedBranding"
        />
      </OffsetColorBox>
    </GradientHeader>
  </div>
</template>

<script setup>
// @ts-check

import { computed, defineProps, ref, watch, onMounted } from 'vue'

import { useRouter } from 'vue-router/composables'

import { t } from '@/locales'

import { useOtp } from '@/composables/useOtp'
import { useFlagEnabled } from '@/composables/useFlagEnabled'

import GradientHeader from '@/components/library/GradientHeader.vue'
import OffsetColorBox from '@/components/library/OffsetColorBox.vue'
import IconCircular from '@/components/icons/IconCircular.vue'
import LockIcon from '@/components/icons/LockIcon.vue'
import OtpSendScreen from '@/components/screens/OtpSendScreen.vue'
import OtpEntryScreen from '@/components/screens/OtpEntryScreen.vue'
import LoadingSpinner from '@/components/LoadingSpinner.vue'

const props = defineProps({
  branding: Object,
  getEnvelope: Function
})

const router = useRouter()

const { sendOtp, verifyOtp, otpStatus } = useOtp()
const [loading, enabled] = useFlagEnabled('signing-page-otp-signers')

const showEntry = ref(false)

const colours = computed(() => props.branding ? props.branding.colours : { accentSecondary: '#ffffff' })
const logo = computed(() => props.branding && props.branding.logo)

async function handleVerifyOtp (otpCode) {
  if (await verifyOtp(otpCode)) {
    props.getEnvelope()
  }
}

onMounted(() => {
  if (!loading.value && !enabled.value) {
    router.replace({
      name: 'PageError',
      params: {
        errorMessage: t('otp.notEnabled')
      }
    })
  }
})
watch(loading, () => {
  if (!loading.value && !enabled.value) {
    router.replace({
      name: 'PageError',
      params: {
        errorMessage: t('otp.notEnabled')
      }
    })
  }
})
</script>
